module.exports = __webpack_public_path__ + "assets/L3Parallel.6a4b00331ade4478561c3d96bf1be2da.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/L3Parallel.gmt
// module id = 961
// module chunks = 0